<template>
      <div :id="id" ref="confirmModalRef" class="modal-overlay hidden" :class="{ 'dark-theme': isDark }" @click.self="closeModal">
        <div class="modal-container">
          <div class="modal-icon-wrapper">
            <div class="modal-icon">
              <span v-if="!isCancel" class="cancel-icon">×</span>
              <!-- SVG Icon for Renew -->
              <svg v-if="isCancel" class="renew-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>
              </svg>
            </div>
          </div>
          <div class="modal-body">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <p class="modal-text">{{ modalText }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-modal btn-danger" @click="confirmAction">
              {{ $t('profile.modal.cancelConfirm') }}
            </button>
            <button type="button" class="btn btn-modal btn-secondary" @click="closeModal">
              {{ $t('profile.modal.cancel') }}
            </button>
          </div>
        </div>
      </div>
</template>
<script setup>
import { defineEmits, defineProps, ref } from "vue";
const props = defineProps({
  modalTitle: String,
  id: String,
  modalText: String,
  isCancel: Boolean,
  isDark: Boolean
});

const confirmModalRef = ref(null)
const emit = defineEmits(["confirmAction"]);
const confirmAction = () => {
  emit("confirmAction");
};
const showModal = () => {
  confirmModalRef.value?.classList.remove('hidden')
}
const closeModal = () => {
  confirmModalRef.value?.classList.add('hidden')
};

defineExpose({
  showModal,
  closeModal
})

</script>

<style>
/* Dark Mode - Confirm Modal */
.dark-theme.modal-overlay .modal-container,
.dark-theme .modal-container {
  background-color: #1E1E1E;
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-title,
.dark-theme .modal-title {
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-text,
.dark-theme .modal-text {
  color: #a0a0a0;
}
.dark-theme.modal-overlay .btn-secondary,
.dark-theme .btn-secondary {
  background-color: #333;
  color: #ffffff;
}
.dark-theme.modal-overlay .btn-secondary:hover,
.dark-theme .btn-secondary:hover {
  background-color: #444;
  color: white !important;
}
</style>